// Func = limiting Scope for this file
var lastScrollTop = 0

if ('NodeList' in window && !NodeList.prototype.forEach) {
	console.info('polyfill for IE11')
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this)
		}
	}
}

;(function () {
	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll('p') || []
	paragraph.forEach(
		(e) => e.innerHTML.trim() === '' && e.parentNode.removeChild(e),
	)
	window.onload = function () {
		scrollW()
		window.addEventListener('scroll', function () {
			scrollW()
		})
	}

	//Information for header Park
	const header = document.querySelector('#default-park');
	if (header) {
		const body = document.body;
		const headerOperation = document.querySelector('[data-operation]');
		const dataOperation = document.querySelector('[data-hours]');
		const dataLatitude = document.querySelector('[data-langitud]').dataset.langitud;
		const dataLongitude = document.querySelector('[data-longitud]').dataset.longitud;
		const link = document.querySelector('.intro-park__hourscontent a');
		const closedDates = [
			'2026-03-04',
			'2026-03-09',
			'2026-03-10'
		];
		const today = new Date();
		const year = today.getFullYear();
		const month = String(today.getMonth() + 1).padStart(2, '0');
		const day = String(today.getDate()).padStart(2, '0');
		const currentDate = `${year}-${month}-${day}`;
		const isSpecialLocation = body.classList.contains('southshore-bay-lagoon-wimauma');
		const isClosedDate = closedDates.includes(currentDate);
		if (isSpecialLocation && isClosedDate) {
			headerOperation.innerHTML = `<a href="${link.href}" class="link-middle"><strong>Closed</strong></a>`;
		} else {
			headerOperation.innerHTML = `<a href="${link.href}" class="link-middle">${dataOperation.innerHTML}</a>`;
		}
		weatherAPI(dataLatitude, dataLongitude, '[data-temperature]');
	}


	////////////////////

	//change main logo for header
	const templateLogo = document.querySelector('#default-park')
	if (templateLogo) {
		const headerLogo = document.querySelector('.header .logo img')
		const dataLogo =
			document.querySelector('[data-headerlogo]').dataset.headerlogo
		if (dataLogo) {
			headerLogo.src = dataLogo
		}
	}

	// submenu
	let itemsMenu = document.querySelectorAll(
		'.privary-navigation .privary-navigation__item',
	)
	itemsMenu.forEach((itemMenu) => {
		if (itemMenu.querySelector('.submenu')) {
			const event = ['mouseenter', 'mouseleave']
			event.forEach((event) => {
				itemMenu.addEventListener(event, () => {
					itemMenu.classList.toggle('hover')
					itemMenu.querySelector('.submenu').classList.toggle('show')
				})
			})
		}
	})

	if (window.innerWidth <= 900) {
		const menu_Items = document.querySelectorAll(
			'#privary-navigation li:has(.submenu)',
		)
		let prevMenuItem

		menu_Items.forEach((element) => {
			// active for link generate in js
			let Main_Link = element.querySelector('a')
			let Link_url = Main_Link.href
			let Element_wrap = element.querySelector('.submenu')
			const newListItem = `
				<li class="privary-navigation__item primary-nav-js">
					<a tabindex="-1" aria-haspopup="false"  href="${Link_url}">Overview</a>
				</li>`

			//Element_wrap.insertAdjacentHTML('afterbegin', newListItem)

			// active for link generate in js
			if (Main_Link.classList.contains('active')) {
				Main_Link.nextElementSibling.querySelector('a').classList.add('active')
			}

			if (
				[...Main_Link.nextElementSibling.querySelectorAll('a')].some((item) =>
					item.classList.contains('active'),
				)
			) {
				Main_Link.nextElementSibling.classList.add('active')
			}

			Main_Link.addEventListener('click', (e) => {
				e.preventDefault()
				if (prevMenuItem && prevMenuItem != e.target.nextElementSibling)
					prevMenuItem.classList.remove('active')
				e.target.nextElementSibling.classList.toggle('active')
				prevMenuItem = e.target.nextElementSibling
			})
		})
	}

	//function for Menu Burger
	setupToggle({
		triggerSelectors: '[data-ctaburger]',
		targetSelector: '[data-menuburger]',
	})

	//function for Tickets
	setupToggle({
		triggerSelectors: '[data-ctatickets]',
		targetSelector: '[data-booktickets]',
	})

	//function for Header Locations
	setupToggle({
		triggerSelectors: '[data-ctaparks]',
		targetSelector: '[data-parklocations]',
		bodyClass: window.innerWidth <= 900 ? 'no-scroll' : 'scroll',
	})

	//function for cta with label get ticket
	const allButtons = document.querySelectorAll('.btn:not(.booking-js)')

	allButtons.forEach((button) => {
		if (
			button.innerText === 'Get Tickets' && 
			!button.classList.contains('no-booking') && 
			( button.href == '#' || button.href == '' || button.href.includes('#buy-tickets')) ) {

			button.addEventListener('click', (e) => {
				e.preventDefault()
				console.log(button)
				document.querySelector('[data-booktickets]').classList.toggle('open')
				document.body.classList.toggle('no-scroll')
			})
		}
	})

	const specialLinks = document.querySelectorAll('[data-links-specials]')
	if (specialLinks) {
		specialLinks.forEach((link) => {
			link.addEventListener('click', function (e) {
				e.preventDefault()
				const listTarget = e.target.nextElementSibling
				const isActive = listTarget.classList.toggle('active')
				e.target.textContent = isActive ? 'Learn Less' : 'Learn More'
			})
		})
	}

	//email signup animation
	const allInputsSignUp = document.querySelectorAll(
		'.email-signup .input input',
	)
	if (allInputsSignUp) {
		allInputsSignUp.forEach((input) => {
			input.addEventListener('focus', function () {
				this.parentElement.classList.add('moved')
			})
		})
	}

	//CMS forms label animation
	if (document.getElementsByClassName('form-module__field').length > 0) {
		let allffields = document.getElementsByClassName('form-module__field')

		for (let j = 0; j < allffields.length; j++) {
			if (allffields[j].getElementsByTagName('input').length > 0) {
				if (
					allffields[j].getElementsByTagName('input')[0].type.toLowerCase() !=
						'checkbox' &&
					allffields[j].getElementsByTagName('input')[0].type.toLowerCase() !=
						'radio'
				) {
					allffields[j]
						.getElementsByTagName('input')[0]
						.addEventListener('focus', function () {
							this.parentElement.classList.add('moved')
						})
				}
			}
			if (allffields[j].getElementsByTagName('select').length > 0) {
				allffields[j]
					.getElementsByTagName('select')[0]
					.addEventListener('focus', function () {
						this.parentElement.classList.add('moved')
					})
			}
			if (allffields[j].getElementsByTagName('textarea').length > 0) {
				allffields[j]
					.getElementsByTagName('textarea')[0]
					.addEventListener('focus', function () {
						this.parentElement.classList.add('moved')
					})
			}
		}
	}

	//accordion Functionality
	let normal_accordion = document.querySelectorAll('[data-accodion] .tab-js')
	normal_accordion.forEach((item, i) => {
		item.addEventListener('click', (element) => {
			element.target.classList.toggle('active')
			element.target.nextElementSibling.classList.toggle('active')
		})

		//if (i == 0) item.click()
	})

	//Location Map Functionality
	const mapSection = document.querySelector('.location-map')
	if (mapSection) {
		const all_pins = document.querySelectorAll('[data-pin]')
		const all_cards = document.querySelectorAll('[data-card]')
		const main_card = document.querySelector('[data-maincard]')
		const close_card = document.querySelector('[data-pinclose]')
		all_pins.forEach((item, i) => {
			item.addEventListener('click', (element) => {
				all_pins.forEach((item, index) => {
					item.classList.remove('active')
					all_cards[index].classList.remove('active')
				})
				item.classList.add('active')
				all_cards[i].classList.add('active')
				main_card.classList.add('active')
			})
		})
		close_card.addEventListener('click', (e) => {
			e.preventDefault()
			main_card.classList.remove('active')
		})
	}

	//Columns Tickets functionality
	document.querySelectorAll('.column-tickets__txt ul').forEach((ul) => {
		ul.classList.add(
			ul.childElementCount <= 2
				? 'small'
				: ul.childElementCount <= 4
				? 'medium'
				: 'big',
		)

		ul.querySelectorAll('li').forEach((li) => {
			if (
				li.childNodes.length === 1 &&
				li.firstChild.nodeType === 1 &&
				li.firstChild.tagName === 'SPAN'
			)
				return
			const span = document.createElement('span')
			const rest = document.createDocumentFragment()
			;[...li.childNodes].forEach((n) =>
				n.nodeType === 3 ? span.appendChild(n) : rest.appendChild(n),
			)
			if (span.childNodes.length) {
				li.textContent = ''
				li.appendChild(span)
				li.appendChild(rest)
			}
		})
	})

	//Lightbox for Menus slider
	const customLightboxMenu = new LBX('[data-menu-lbx]', {customClass: 'lightbox-menus'})
	
	//Lightbox for Interactive Pin
	const customLightbox = new LBX('.interactive-pin-lbx', {
		beforeShow:() =>{
			const video_pin = document.querySelector('.lbx_item figure video')
			if (video_pin){
				video_pin.load();
				video_pin.addEventListener('loadeddata',  () => {
					video_pin.play();
				});
			}
		}
	});


})()

function weatherAPI(latitude, longitude, append_Content) {
	const appendContent = document.querySelector(append_Content)

	const WEATHER_API_CONF = {
		getter: 'https://api.openweathermap.org/data/2.5/weather',
		apiKey: '0ddd1af8b5b1833cedd6da7a90934cce',
		unit: 'imperial',
		lat: latitude,
		lon: longitude,
	}

	const url_Fetch = `${
		WEATHER_API_CONF.getter
	}?lat=${WEATHER_API_CONF.lat.trim()}&lon=${WEATHER_API_CONF.lon.trim()}&units=${
		WEATHER_API_CONF.unit
	}&appid=${WEATHER_API_CONF.apiKey}`
	fetch(url_Fetch)
		.then((response) => response.json())
		.then((data) => {
			if (parseInt(data.main.temp) >= 71) {
				const content_Api = `<span>${parseInt(data.main.temp)}°F</span>`
				appendContent.innerHTML = content_Api
			}else{
				console.log(data.main.temp);
			}
		})
}

function scrollW() {
	let st = window.pageYOffset || document.documentElement.scrollTop

	if (st > 80) {
		if (st > lastScrollTop) {
			if (!document.getElementById('header').classList.contains('down')) {
				document.getElementById('header').classList.add('down')
				document.getElementById('header').classList.remove('up')
			}
		} else {
			if (!document.getElementById('header').classList.contains('up')) {
				document.getElementById('header').classList.add('up')
				document.getElementById('header').classList.remove('down')
			}
		}
	} else {
		if (
			document.getElementById('header').classList.contains('up') ||
			document.getElementById('header').classList.contains('down')
		) {
			document.getElementById('header').classList.remove('up', 'down')
		}
	}

	lastScrollTop = st <= 0 ? 0 : st

	if (window.innerWidth < 767 && document.querySelector("#default-park") && document.querySelector(".sub-menu__mobilehold")) {
		const subnavScroll = document.querySelector(".sub-menu__mobilehold");
		const elementparent = subnavScroll.previousElementSibling.offsetHeight;
		const nextelement = subnavScroll.nextElementSibling;
		if (lastScrollTop > (elementparent - 80)) {
			subnavScroll.classList.add("fixed");
			nextelement.classList.add("intro-park--subnav");
		} else {
			subnavScroll.classList.remove("fixed");
			nextelement.classList.remove("intro-park--subnav");
		}
	}
}

function setupToggle({
	triggerSelectors,
	targetSelector,
	bodyClass = 'no-scroll',
	closeSelectors,
}) {
	const triggers = document.querySelectorAll(triggerSelectors)
	const target = document.querySelector(targetSelector)

	if (!target) return

	const toggle = () => {
		target.classList.toggle('open')
		document.body.classList.toggle(bodyClass)
		triggers.forEach((trigger) => trigger.classList.toggle('active'))
	}

	triggers.forEach((trigger) => {
		trigger.addEventListener('click', (e) => {
			e.preventDefault()
			toggle()
		})
	})

	if (closeSelectors) {
		document.querySelectorAll(closeSelectors).forEach((el) => {
			el.addEventListener('click', (e) => {
				e.preventDefault()
				if (target.classList.contains('open')) {
					toggle()
				}
			})
		})
	}
}

//animation of scroll vanilla JS
function animateTo(target) {
	var gotoTarget = offset(document.getElementById(target)).top - 100
	var from = window.pageYOffset
	var to = gotoTarget
	var duration = 1300
	var start = new Date().getTime()

	//time interval
	var timer = setInterval(function () {
		var time = new Date().getTime() - start

		if (from <= to) {
			var yH = easeInOutQuart(time, from, to - from, duration)
		} else {
			var yH = easeInOutQuart(time, from, -(from - to), duration)
		}
		window.scrollTo(0, yH)
		if (time >= duration) clearInterval(timer)
	}, 1000 / 60)

	window.scrollTo(0, from)
}

//ease movement
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return (c / 2) * t * t * t * t + b
	return (-c / 2) * ((t -= 2) * t * t * t - 2) + b
}

//window offset
function offset(el) {
	var rect = el.getBoundingClientRect(),
		scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
		scrollTop = window.pageYOffset || document.documentElement.scrollTop
	return {
		top: rect.top + scrollTop,
		left: rect.left + scrollLeft,
	}
}

//class for scroll
let classtoscroll = document.querySelectorAll('.scroll-js , .btn-scroll')
if (classtoscroll) {
	classtoscroll.forEach((item) => {
		item.addEventListener('click', (e) => {
			e.preventDefault()
			let sectiongoto = e.target.hash.split('#')[1]
			animateTo(sectiongoto)
			if (
				document.querySelector('.sub-menu__hold').classList.contains('open')
			) {
				document.querySelector('.sub-menu__hold').classList.remove('open')
			}
		})
	})
}

/* Subnav on mobile park */
let submenuHold = document.querySelector('#default-park .sub-menu__mobilehold')
let allsublinks = document.querySelectorAll('#default-park  .sub-menu__mobilehold .sub-menu a')
let toggleBtn = document.querySelector('.sub-menu__toggle')
if (allsublinks.length > 1) {
	allsublinks.forEach((ele) => {
		ele.addEventListener('click', function (ev) {
			/*ev.preventDefault()*/
			submenuHold.classList.remove('open')
			/*let sectiongoto = ev.target.href.split('#')[1]
			animateTo(sectiongoto)*/
		})
	})

	if (toggleBtn) {
		//toggleBtn.textContent = document.querySelector('.sub-menu a.active').textContent;
		toggleBtn.addEventListener('click', function () {
			toggleBtn.parentElement.classList.toggle('open')
		})
	}
}


// remove aria-label from flatpickr //
function removeFlatpickrAriaLabel() {
    const calendarDays = document.querySelectorAll('.flatpickr-day');
    let removedCount = 0;
    
    calendarDays.forEach(day => {
        if (day.hasAttribute('aria-label')) {
            day.removeAttribute('aria-label');
            removedCount++;
        }
    });
}
setTimeout(removeFlatpickrAriaLabel, 1000);

const anchor = window.location.hash.slice(1);

if(anchor && anchor == 'buy-tickets'){
	let bookingTarget = document.querySelector('[data-booktickets]');

	bookingTarget.classList.add('open');
	document.body.classList.add('no-scroll');
}